const locale = {
  BUTTON_SHOW_LOG: 'Logs',
  TABLE_HEADER_ROLE_LEVEL: 'Role Level',
  DETAIL_ROLE_LEVEL: 'Role Level',
  DETAIL_CHARTS: 'Charts',
  DETAIL_ID: 'ID',
  DETAIL_HEIGHT: 'Height',
  DETAIL_WIDTH: 'Width',
  DETAIL_FILTER: 'Filter',
  DETAIL_ORDER: 'Order',
  BUTTON_ADD_MORE: 'Add more',
  BUTTON_DELETE: 'Delete',
  UPDATE_DASHBOARD_PERMISSION_SUCCESS: 'Dashboard permission has been updated successfully',
  BUTTON_PRINT: 'Print',
  BUTTON_DONE: 'Done',
  CALENDAR_TITLE: 'Title',
  CALENDAR_BUTTON_TODAY: 'Today',
  CALENDAR_ADD_DETAILS: 'Details',
  CALENDAR_REPEAT: 'Repeat',
  CREATE_CALENDAR_SUCCESS: 'Calendar has been created successfully',
  CREATE_CALENDAR_FAIL: 'Calendar has been create fail',
  CALENDAR_DIALOG_TITLE: 'Add {{type}}',
  DELETE_SCHEDULE_MESSAGE: 'Are you sure want to delete {{type}}?',
  DELETE_SCHEDULE_TITLE: 'Delete {{type}}',
  SCHEDULE_TITLE: 'Schedule',
  SCHEDULE_TAB_TODAY: 'Today',
  SCHEDULE_TAB_WEEK: 'Week',
  SCHEDULE_TAB_MONTH: 'Month',
  SCHEDULE_TAB_YEAR: 'Year',
  SCHEDULE_PREVIOUS_MONTH: 'Previous month',
  SCHEDULE_NEXT_MONTH: 'Next month',
  SCHEDULE_PREVIOUS_YEAR: 'Previous year',
  SCHEDULE_NEXT_YEAR: 'Next year',
  SCHEDULE_SUMMARY_TODAY: '{{date}}',
  SCHEDULE_SUMMARY_RANGE: '{{range}}',
  SCHEDULE_SUMMARY_MONTH: '{{month}}',
  SCHEDULE_SUMMARY_YEAR: '{{year}}',
  SCHEDULE_SUMMARY_TOTAL: 'Year items',
  SCHEDULE_SUMMARY_NOTE: 'Note',
  SCHEDULE_SUMMARY_REMINDER: 'Reminder',
  SCHEDULE_SUMMARY_TASK: 'Task',
  SCHEDULE_SUMMARY_ITEM_VALUE: '{{label}}: {{count}}',
  SCHEDULE_EMPTY_HINT_PREFIX: 'To create an entry, select',
  SCHEDULE_EMPTY_HINT_SUFFIX: 'on the calendar',
  SCHEDULE_EMPTY_ICON_ALT: 'Add schedule',
  SCHEDULE_PLUS_MORE: '+{{count}} more',
  SCHEDULE_MORE: '{{count}} more',
  SCHEDULE_MARK_DONE: 'Mark as done',
  SCHEDULE_MARK_NOT_DONE: 'Mark as not done',
  SCHEDULE_OPEN_DAY: 'View all items for this day',
  SCHEDULE_OPEN_MONTH: 'Open {{month}}',
  SCHEDULE_DAY_COUNT: '{{count}} items',
  SCHEDULE_READ_MORE: 'Read more',
  NOTICE_TITLE: 'Notice',
  NOTICE_SUBTITLE: 'Important updates from myPak Support',
  NOTICE_ACTION: 'Read more',
  NOTICE_READ_MORE: 'Read more',
  NOTICE_COUNT: '{{count}} notices',
  NOTICE_EMPTY: 'No help centre articles available',
  ANNOUNCEMENT_LEARN_MORE: 'Learn More',
  ANNOUNCEMENT_READ_MORE: 'Read More',
  HELP_CENTRE_TITLE: 'Help Centre',
  HELP_CENTRE_VIEW_ALL: 'View all',
  RECENT_PATIENT_ACTIVITY_TITLE: 'Recent Patient Activity',
  PATIENT_ACTIVITY_EMPTY: 'No recent patient activity',
  PATIENT_ACTIVITY_BY_USER: 'by {{user}}',
  PATIENT_ACTIVITY_TYPE_NEW: 'Drug Added',
  PATIENT_ACTIVITY_TYPE_UPDATED: 'Drug Updated',
  PATIENT_ACTIVITY_TYPE_DELETED: 'Drug Deleted',
  PATIENT_ACTIVITY_TYPE_CEASED: 'Drug Ceased',
  PATIENT_ACTIVITY_TYPE_BRAND_SWAPPED: 'Drug Brand Swapped',
  PATIENT_ACTIVITY_TYPE_UNKNOWN: 'Activity',
  NOTICE_DYNAMIC_NEWS_TYPE: 'News',
  NOTICE_DYNAMIC_ARTICLE_TYPE: 'Article',
  NOTICE_DYNAMIC_FALLBACK_TITLE: 'Help Centre Update',
  NOTICE_DYNAMIC_NEWS_DESCRIPTION: 'Open this latest help centre news post.',
  NOTICE_DYNAMIC_ARTICLE_DESCRIPTION: 'Open this latest help centre article.',
  EDIT_DIALOG_SCHEDULE: 'Edit {{type}}',
  BUTTON_SAVE_CHANGE: 'Save Changes',
  SCHEDULE_TITLE_TITLE: 'Title',
  SCHEDULE_TITLE_DETAIL: 'Detail',
};

export default locale;
